import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgStateAccepted = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 12,
	height: 10,
	viewBox: "0 0 12 10",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M10.56.5 12 1.96 4.564 9.5 0 4.873l1.44-1.46 3.124 3.165L10.559.5z",
		fill: "#0A8A00"
	})
});
export default SvgStateAccepted;
